import api from './index.js';

export const athletesApi = {
  list: () => api.get('/athletes').then(r => r.data),
  get: (id) => api.get(`/athletes/${id}`).then(r => r.data),
  create: (data) => api.post('/athletes', data).then(r => r.data),
  update: (id, data) => api.put(`/athletes/${id}`, data).then(r => r.data),
  delete: (id) => api.delete(`/athletes/${id}`).then(r => r.data),
  getStats: (id) => api.get(`/api/stats/athlete/${id}`).then(r => r.data),
  getLandings: (id) => api.get(`/athletes/${id}/landings`).then(r => r.data),
  getSkills: (id) => api.get(`/athletes/${id}/skills`).then(r => r.data),
};

export default athletesApi;
